export default {
    props: ['link', 'rows', 'rowClass', 'highlightedItems', 'keyFunc'],
    render(h) {
        return h('tbody', {}, this.renderChildren())
    },
    methods: {
        renderChildren() {
            // these are the things that can render a table cell in a row
            const columns = this.$slots.default.filter(c => !!c && c.componentInstance).map(c => c.componentInstance)

            if (!columns || columns.length == 0) {
                return []
            }

            const h = this.$createElement

            // these are the things that can render additional rows
            const appenders = this.$parent.$children.filter(s => !!s.appendTableRows)

            const keyFunc = this.keyFunc ?? ((row, index) => row.id || row.key || `__index${index}`)

            let rendered = []

            this.rows.forEach((row, index) => {
                const key = keyFunc(row, index)

                let classes = []

                if (this.highlightedItems.indexOf(row) > -1) {
                    classes.push('highlighted')
                }

                if (this.rowClass !== null) {
                    classes.push(this.rowClass(row, index, this.rows))
                }

                rendered.push(
                    h(
                        'tr',
                        {
                            attrs: { class: classes.join(' ') },
                            key: `row-${key}`,
                            on: {
                                dblclick: () => {
                                    if (this.link) {
                                        this.$router.push(this.link(row))
                                    }
                                },
                                click: () => this.$emit('click', row),
                            },
                        },
                        columns.map(c => c.renderTableCell(row, this.link, index, this.rows))
                    )
                )

                appenders.forEach(a => rendered.push(...a.appendTableRows(columns.length, row, key, index)))
            })
            return rendered
        },
    },
}
